import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { clearUserState, signinRedirectCallback, signoutRedirect } from "../../store/modules/auth/authServices";

function SignInOidc() {
  const navigate = useNavigate();

  useEffect(() => {
    async function signinAsync() {
      try {
        await signinRedirectCallback();
      } catch (err: any) {
        if (err.error === "access_denied") {
          clearUserState();
          navigate("/");
        } else {
          signoutRedirect();
        }
        return;
      }

      const returnUrl = sessionStorage.getItem("returnUrl") || "/";
      sessionStorage.removeItem("returnUrl");
      navigate(returnUrl);
    }
    signinAsync();
  }, [navigate]);

  return null;
}

export default SignInOidc;
